// extracted by mini-css-extract-plugin
export default {"imgBox":"Ww7ro2rYThYb9D6N2qTs","hoverBg":"hQIrJNxNjTUpg4_P52Qe","playIconBox":"GUL9u0uGqXeZqGl_b5qU"};